var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.58,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#CACDCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.132 31.727s1.433 10.032-.233 12.832c-2.767 3.5-7.366 4.533-13.899 7.7 3.266 7.599 6.766 13.065 10.332 16.631a38.41 38.41 0 0010.066 1.333c4.733 0 9.266-.866 13.432-2.433 3.367-3.7 6.4-8.866 8.933-15.132-10.133-5.766-10.666-5.366-13.2-8.099-1.399-1.5-1.899-5.3-2.132-13.432l-13.299.6z",
    fill: "#9C9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.299 33.027l13.299 1.867c.266 5.6.833 8.432 2 9.666l.1.1c-9.2 2.9-11.864-1.914-15-5.1.034-2.4-.3-5.666-.4-6.533z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.797 22.029c-.433 0-.733.366-.966 1 1.133-19.932-21.532-18.565-20.732-.067-.233-.6-.533-.967-.966-.967-2.7-.233-.134 11.5 1.466 7.9 4.233 13.565 15.699 13.398 19.665-.3 1.133 4.633 4.57-7.6 1.533-7.566z",
    fill: "#9C9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.17 46.152s2.956 5.33 8.612 5.33c7.935 0 9.643-5.051 9.643-5.051l.278-.52s1.866.556 2.714.908c.848.35 8.794 2.483 10.248 6.48 0 0 .69 17.443-21.635 17.443C7.705 70.742 8.335 53.3 8.335 53.3c0-5.693 10.042-6.638 11.835-7.147z",
    fill: "#747779"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FFD2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.264 45.648c-.452-.306-.724-.814-.972-1.334a6.693 6.693 0 01-.724-.487c-1.289-.916-1.018-3.392-.6-5.212-.53.452-.915.735-.915.735s-1.153 1.345-2.013 1.605c-1.074.317-2.114.814-4.025.08-.52-.204-1.617-1.583-2.114-2.036-.441-.407-.848-.791-1.221-1.142.045.43.022.746-.057 1.221a8.692 8.692 0 01-.08.487c-.078 1.673-.338 3.37-1.005 4.432-.204.328-.577.678-1.007 1.017a4.291 4.291 0 000 .532v.056c0 .023 0 .046.012.068a3.6 3.6 0 00.158.792l.034.102c-.305-.147-.837-.396-1.47-.69-1.187.723-11.827 1.402-11.827 6.942h40.4c-1.923-4.522-10.855-5.992-12.574-7.168z",
    fill: "#DD2762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 45.715c-.035-.022-.08-.045-.114-.068-.452-.305-.723-.825-.983-1.345a8.565 8.565 0 01-.713-.464c-1.289-.915-1.017-3.392-.599-5.212-.531.452-.916.735-.916.735s-1.153 1.345-2.012 1.606c-1.075.316-2.115.814-4.026.079-.52-.204-1.616-1.583-2.114-2.035-.452-.419-.87-.803-1.255-1.165.068.509.011 1.108-.113 1.73l-.034.622c1.323 1.933 5.031 5.947 12.878 5.517z",
    fill: "#CB1F57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.928 38.675c-.418 1.81-.552 3.869.469 5.23 1.02 1.361 1.683 1.711 1.71 1.711 1.934 1.142 4.452 1.076 4.35 1.008 0 0-.147-2.737.848-3.743.995-1.017 2.329-1.877 2.329-1.877s1.832-1.922.893-2.329c-.938-.407.543-.961.543-.961l-1.04-.758s1.583-.35 1.04-1.119c-.543-.758 1.583-3.29 1.583-3.29s.939-1.165-.645-3.845c-1.582-2.68-.995-5.11-.995-5.11-.791-2.974-2.012-8.141-5.2-10.742-1.482-1.164-2.85-3.799-5.224-4.104-.837-.102-2.409.203-2.409.203s-4.116-1.99-6.67-1.04c-2.534.961-6.502 3.483-9.68 7.429-3.177 3.946-1.141 5.416-1.141 5.416s-.747.248-1.04-1.221c0 0-.77 1.515 0 2.736 0 0-4.015 4.41-2.873 6.682a8.34 8.34 0 00.713 1.165c-.701.78-2.228 2.725-1.651 4.308.226.61-.215 1.029-.045 1.38.305.61.836 1.062 1.48 1.254l.713 2.07a8.59 8.59 0 004.421 4.963c.712.34 2.522 1.198 3.901 1.854l1.47.69-.034-.102c-.475-1.951.79-1.728 1.312-3.292.508-1.523.842-3.703.644-5.335-.333-2.495 11.302-3.884 10.228.769z",
    fill: "#6E0D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.85 36.252c.17-.193.407-.453.667-.747.419-.497.894-1.108 1.188-1.64a4.27 4.27 0 00.282-.734c0-.011 0-.023.012-.034.01-.034.01-.056.022-.09.08-.407.09-.803.068-1.108a7.636 7.636 0 00-.08-.622c-.056-.43 1.425-.08 1.787-.758.011-.034.034-.056.045-.09.012-.034.034-.057.046-.09.011-.023.023-.057.034-.08.01-.023.022-.056.034-.08.01-.022.022-.056.034-.078.01-.023.022-.057.033-.08.012-.033.023-.056.034-.09a.154.154 0 00.023-.079c.011-.034.022-.068.034-.09.011-.023.011-.046.022-.08a.324.324 0 00.023-.101c.011-.023.011-.046.023-.068.011-.034.011-.068.022-.102.012-.023.012-.045.023-.068.011-.034.011-.068.023-.102 0-.022.01-.045.01-.079.012-.034.012-.067.012-.101 0-.023.011-.046.011-.08s.012-.067.012-.101c0-.023.011-.046.011-.08 0-.033.011-.067.011-.101 0-.023 0-.057.012-.08v-.7c0-.056-.012-.113-.023-.18-.17-1.448-.373-2.714-1.673-2.183-.328.136-.419.453-.532.441-.803-.045-1.04-.836-1.051-1.888v-.305c0-.215.022-.43.034-.656.01-.113.022-.226.022-.34 0-.056.012-.112.012-.169.022-.282.056-.576.09-.859.158-1.56.294-3.03-.362-3.415-.045-.022-.09-.045-.147-.067a8.377 8.377 0 01-1.775-.747c-.86-.486-1.425-1.029-1.786-1.47l-.034-.034c-.238-.294-.373-.52-.441-.621-.034-.012-.068-.023-.09-.034-.148.068-.363.192-.657.361a16.305 16.305 0 00-3.392 2.658c-2.125 2.182 0 0-2.826 2.532-2.092 1.877-1.334.61-3.178 2.33-.554.52-.644 2.498-.87 3.572-.113.566-.939-1.402-.984.272-.045 1.38.532 1.843.419 2.996-.227 2.375 1.549 4.726 3.143 6.66.282.316.407.904.43 1.074v.034c.373.35.78.735 1.22 1.142.487.452 1.584 1.832 2.115 2.035 1.91.735 2.951.237 4.025-.08.86-.259 2.013-1.604 2.013-1.604s.329-.208.872-.66c.271-1.187.643-2.156.643-2.156s.136-.125.305-.305z",
    fill: "#DD2762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.44 46.144s2.758 4.975 8.038 4.975c7.406 0 9-4.715 9-4.715l.26-.486s1.742.52 2.533.848c.792.328 8.209 2.318 9.566 6.049 0 0 .644 16.282-20.194 16.282-20.839 0-20.25-16.282-20.25-16.282 0-5.314 9.373-6.196 11.046-6.67z",
    fill: "#A0084C"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30.58,
    r: 29,
    stroke: "#fff",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__b"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.58,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 1)",
    d: "M0 0h29v27H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.41afb9299c68721481bcc4fbae2afff5.svg";
export { ForwardRef as ReactComponent };